import { Link } from "@/components/LLink";
import { ArrowRight } from "lucide-react";
import { CONTACT } from "@/data/site";
import { useLang } from "@/i18n";

export default function QuoteCTA({ kicker, title, text }) {
  const { t } = useLang();
  kicker = kicker || t("cta_k");
  title = title || t("contact_title");
  text = text || t("cta_x");
  return (
    <section data-testid="quote-cta">
      <div className="mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:px-8">
        <div className="grid gap-8 bg-ink px-8 py-12 sm:px-12 lg:grid-cols-[1fr_auto] lg:items-center lg:px-16 lg:py-14">
          <div>
            <p className="text-[12px] font-semibold uppercase tracking-[0.25em] text-gold">{kicker}</p>
            <h2 className="mt-3 font-heading text-3xl font-semibold leading-tight text-base md:text-4xl">{title}</h2>
            <p className="mt-4 max-w-xl text-[15px] leading-relaxed text-base/65">{text}</p>
          </div>
          <div className="flex flex-wrap items-center gap-6">
            <Link to="/contact" data-testid="quote-cta-button" className="inline-flex items-center gap-2 bg-base px-7 py-3.5 text-[14px] font-semibold text-ink transition-colors duration-300 hover:bg-gold hover:text-base">
              {t("nav_cta")} <ArrowRight className="h-4 w-4" />
            </Link>
            <a href={CONTACT.phoneHref} data-testid="quote-cta-phone" className="text-[14px] font-medium text-base/70 underline decoration-gold decoration-2 underline-offset-[6px] transition-colors hover:text-base">
              {CONTACT.phone}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
